import { render } from "./updateproduct.vue?vue&type=template&id=0c082dcf"
import script from "./updateproduct.vue?vue&type=script&lang=js"
export * from "./updateproduct.vue?vue&type=script&lang=js"

import "./updateproduct.vue?vue&type=style&index=0&id=0c082dcf&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__